var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import Text from "../Text/index.js";
import styles from "@bookingcom/bui-core/css/Bubble.module.css";
var Bubble = function (props) {
    var ariaLabel = props.ariaLabel, _a = props.variant, variant = _a === void 0 ? "neutral" : _a, _b = props.text, text = _b === void 0 ? "" : _b, _c = props.maxValue, maxValue = _c === void 0 ? 99 : _c, className = props.className, attributes = props.attributes, mixin = props.mixin;
    var rootClassName = classNames(styles.root, className, variant && styles["root--variant-".concat(variant)]);
    var bubbleText = text;
    if (typeof text === "number") {
        bubbleText = text <= maxValue ? text : "".concat(maxValue, "+");
    }
    return (React.createElement(Text, { attributes: __assign(__assign({}, attributes), { "aria-label": ariaLabel }), className: rootClassName, variant: "small_1", mixin: mixin }, bubbleText));
};
export default Bubble;
